/**
 * Composant de message d'alerte
 */
import React, { useEffect, useState } from 'react';
import './AlertMessage.css';
import './AlertMessage.css';

interface AlertMessageProps {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  onClose?: () => void;
  autoClose?: boolean;
  duration?: number;
}

const AlertMessage: React.FC<AlertMessageProps> = ({
  type,
  message,
  onClose,
  autoClose = true,
  duration = 5000,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (autoClose && duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        onClose?.();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose]);

  if (!isVisible || !message) {
    return null;
  }

  const getIcon = (): string => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '!';
      case 'info':
        return 'i';
      default:
        return '';
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    onClose?.();
  };

  return (
    <div className={`alert-message alert-${type}`}>
      <span className="alert-icon">{getIcon()}</span>
      <span className="alert-text">{message}</span>
      {onClose && (
        <button
          className="alert-close"
          onClick={handleClose}
          aria-label="Fermer"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default AlertMessage;
